<template>
  <div>
    <div>
      <el-main class="main">
        <div class="content">
          <div class="download">
            <div class="common">
              <div class="icon">
                <img :src="message.in_icon">
              </div>
              <div class="name">
                <p class="name-t">{{message.in_name}}</p>
                <div class="install_load" v-if="!isPassword && instaling">
                  {{$t('lange.instaling')}}
                </div>
                <div class="ios_but" v-if="!isPassword && instalComplete">
                  <a @click="downDescribe"
                    v-if="message.in_form == 'iOS' && message.in_super == 0 && message.in_type == 2">{{$t('lange.iosDescribe')}}</a>
                  <a @click="downDescribe"
                    v-if="message.in_form == 'iOS' && message.in_super == 1">{{$t('lange.superDescribe')}}</a>
                </div>
                <div class="down_teach" v-if="!isPassword && down_url != 'http://' && down_url != 'https://'">
                  <p class="teach_nosuper"
                    v-if="message.in_form == 'iOS' && message.in_super== 0   && message.in_type == 2" @click="opentech">
                    <i class="el-icon-thumb"></i>&nbsp;&nbsp;{{$t('lange.downipa')}}
                  </p>
                  <p class="teach_super" v-if="message.in_form == 'iOS' && message.in_super== 1"
                    @click="isTeach = true">
                    <i class="el-icon-thumb"></i>&nbsp;&nbsp;{{$t('lange.downsuper')}}
                  </p>
                </div>
                <div class="download_but"
                  v-if="!isPassword && down_url != 'http://' && down_url != 'https://' && downbut">
                  <a @click="downAndroid" v-if="message.in_form == 'Android'&&mobile == 2">
                    <i class="el-icon-download"></i>&nbsp;<span>{{$t('lange.download')}}</span>
                  </a>
                  <a @click="downIpa" v-if="!message.in_super && message.in_form == 'iOS'&&mobile == 1">
                    <i class="el-icon-download"></i>&nbsp;<span>{{$t('lange.download')}}</span>
                  </a>
                  <a @click="downSuper" v-if="message.in_super && message.in_form == 'iOS'&&mobile == 1">
                    <i class="el-icon-download"></i>&nbsp;<span>{{$t('lange.download')}}</span>
                  </a>
                </div>
                <div class="download_but" v-if="!isPassword && downbut && down_url == ''">
                  <div style="height:10px"></div>
                  <a><span>
                      {{is_merge == "1"?$t('lange.iOSAndroid'):(message.in_form == 'Android'?$t('lange.facilityAndroid'):$t('lange.facilityiPhone'))}}
                    </span></a>
                </div>
              </div>
            </div>
            <div class="rate-info">
              <div class="rate">
                <strong>4.9</strong>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAAgCAYAAAC8eIxyAAADiElEQVR4nNXcvascVRgH4GfXWySKFoIouYJ2gogS1ELFr4hJlPgdP1CihWBhYaOd/4CNEcTSKsZCESxMo3axsBAEtRVUgogfGFEsDFxiMRtyWbI7s3Nmzt3fr9ndmT3vPFu8s+ycszM5+tbbBsh+fDZEoQpJsSY4E4wM5JwOALkXn+KmAWqNnRRrgjPByIDOIZrl9dnjkQFqjZ0Ua4IzwciAztJmuQ77Zs+fw0ZhvTGTYk1wJhgZ2FnaLC9iMnt+Fe4vrDdmUqwJzgQjAztLmmWKZ+e2PV9Qb8ykWBOcCUZGcJY0yz5szm17BJcV1BwrKdYEZ4KREZwlzXKhH0y78VRBzbGSYk1wJhgZwdm3WS7GYwv2rdvVkRRrgjPByEjOVa8O7MYuzZWFSxe8507ciFML9m/h7xWP2ycp1gRngpGRnRu4At/hyiLm+UzwTY9xR3C85T0p1gRngpE1ck7xO04MBOmTs3hNe6OQY01wJhhZI+e53ywv45MdgJzRnFneXGFMijXBmWBkTZzTbRsP46OKkH9wCO+vOC7FmuBMMLImzu1Xw87gGbxbAfIT7sDnPcenWBOcCUbWwHnRgYMPbH99VvN1959mUmdi+HyJ+/BDYZ0Ua4IzwcgOOxfNs7yh+dr7d2DIMc2S6d8GrJliTXAmGNkh57JJyY9xO74fALGFV/GC5qwwdFKsCc4EIzvgbJvB/xa3Krt0dxoP4mhBjS5JsSY4E4xUdnZZ7vIXHsZXPTHvqffX0xRrgjPBSEVn17Vhu3B9T8wTKxxniKRYE5wJRio5u36Y/bikJ2YTt/Uc2ycp1gRngpFKzq7NsmgFZ9ccLhy/SlKsCc4EI5WcXZplAw+VWTxaOL5rUqwJzgQjFZ1dmuUuXL5k/xZOttS4Fnu7gAqTYk1wJhip6OzSLMu+4n7UTOLcrenuX5e8t8ZZJsWa4EwwUtHZ1iyTJUWOaW5c9sXs9QncYPFit0NtmMKkWBOcCUYqO9ua5RZcPbftTzytme2c/0fZH3hSs6z59Ny+vdjTBipIijXBmWCksrOtWea79gNNd37YMu64pqu3r9qc4GDLuJKkWBOcCUYqO9ua5fHZ40nco1ki/UvLmHM5hQN4STPLyvm7A46RFGuCM8FIZedkyV30p3hlBvm6I2BR9uAd3IxrCmtdKCnWBGeCkR1wLmuWMbKJn2sesCAp1gRngpEW5//kXI9EZibN2wAAAABJRU5ErkJggg=="
                  alt="">
                <p>9999+ 评分</p>
              </div>
              <div class="classification" style="text-align: center">
                <strong>4+</strong>
                <p>年龄</p>
              </div>
            </div>
          </div>
          <div class="describe">
            <div class="common">
              <hr class="hr" v-if="!isPassword">
              <div class="describe-block" v-if="!isPassword">
                <div class="describe-block-t">
                  {{$t('lange.introduce')}}
                </div>
                <p class="describe-block-p" v-html="message.in_appintro ==''?message.in_name:message.in_appintro">
                </p>
              </div>
              <div class="describe-block" v-if="!isPassword && message.in_remark">
                <div class="describe-block-t">
                  {{$t('lange.remark')}}
                </div>
                <p class="describe-block-p">
                  {{message.in_remark}}
                </p>
              </div>
            </div>
          </div>
          <div class="comment-info">
            <h2 class="comment-info-title"></h2>
            <div class="comment-info-content">
              <div class="comment-info-l"><strong data-v-5cecdd32="">4.9</strong>
                <p>满分 5 分</p>
              </div>
              <div class="comment-info-r">
                <ul class="comment-star-list">
                  <li>
                    <div class="comment-star">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAAgCAYAAAC8eIxyAAADiElEQVR4nNXcvascVRgH4GfXWySKFoIouYJ2gogS1ELFr4hJlPgdP1CihWBhYaOd/4CNEcTSKsZCESxMo3axsBAEtRVUgogfGFEsDFxiMRtyWbI7s3Nmzt3fr9ndmT3vPFu8s+ycszM5+tbbBsh+fDZEoQpJsSY4E4wM5JwOALkXn+KmAWqNnRRrgjPByIDOIZrl9dnjkQFqjZ0Ua4IzwciAztJmuQ77Zs+fw0ZhvTGTYk1wJhgZ2FnaLC9iMnt+Fe4vrDdmUqwJzgQjAztLmmWKZ+e2PV9Qb8ykWBOcCUZGcJY0yz5szm17BJcV1BwrKdYEZ4KREZwlzXKhH0y78VRBzbGSYk1wJhgZwdm3WS7GYwv2rdvVkRRrgjPByEjOVa8O7MYuzZWFSxe8507ciFML9m/h7xWP2ycp1gRngpGRnRu4At/hyiLm+UzwTY9xR3C85T0p1gRngpE1ck7xO04MBOmTs3hNe6OQY01wJhhZI+e53ywv45MdgJzRnFneXGFMijXBmWBkTZzTbRsP46OKkH9wCO+vOC7FmuBMMLImzu1Xw87gGbxbAfIT7sDnPcenWBOcCUbWwHnRgYMPbH99VvN1959mUmdi+HyJ+/BDYZ0Ua4IzwcgOOxfNs7yh+dr7d2DIMc2S6d8GrJliTXAmGNkh57JJyY9xO74fALGFV/GC5qwwdFKsCc4EIzvgbJvB/xa3Krt0dxoP4mhBjS5JsSY4E4xUdnZZ7vIXHsZXPTHvqffX0xRrgjPBSEVn17Vhu3B9T8wTKxxniKRYE5wJRio5u36Y/bikJ2YTt/Uc2ycp1gRngpFKzq7NsmgFZ9ccLhy/SlKsCc4EI5WcXZplAw+VWTxaOL5rUqwJzgQjFZ1dmuUuXL5k/xZOttS4Fnu7gAqTYk1wJhip6OzSLMu+4n7UTOLcrenuX5e8t8ZZJsWa4EwwUtHZ1iyTJUWOaW5c9sXs9QncYPFit0NtmMKkWBOcCUYqO9ua5RZcPbftTzytme2c/0fZH3hSs6z59Ny+vdjTBipIijXBmWCksrOtWea79gNNd37YMu64pqu3r9qc4GDLuJKkWBOcCUYqO9ua5fHZ40nco1ki/UvLmHM5hQN4STPLyvm7A46RFGuCM8FIZedkyV30p3hlBvm6I2BR9uAd3IxrCmtdKCnWBGeCkR1wLmuWMbKJn2sesCAp1gRngpEW5//kXI9EZibN2wAAAABJRU5ErkJggg=="
                        alt="">
                      <div style="width: 0%;"></div>
                    </div>
                    <div class="comment-progress">
                      <div style="width: 90%;"></div>
                    </div>
                  </li>
                  <li>
                    <div class="comment-star">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAAgCAYAAAC8eIxyAAADiElEQVR4nNXcvascVRgH4GfXWySKFoIouYJ2gogS1ELFr4hJlPgdP1CihWBhYaOd/4CNEcTSKsZCESxMo3axsBAEtRVUgogfGFEsDFxiMRtyWbI7s3Nmzt3fr9ndmT3vPFu8s+ycszM5+tbbBsh+fDZEoQpJsSY4E4wM5JwOALkXn+KmAWqNnRRrgjPByIDOIZrl9dnjkQFqjZ0Ua4IzwciAztJmuQ77Zs+fw0ZhvTGTYk1wJhgZ2FnaLC9iMnt+Fe4vrDdmUqwJzgQjAztLmmWKZ+e2PV9Qb8ykWBOcCUZGcJY0yz5szm17BJcV1BwrKdYEZ4KREZwlzXKhH0y78VRBzbGSYk1wJhgZwdm3WS7GYwv2rdvVkRRrgjPByEjOVa8O7MYuzZWFSxe8507ciFML9m/h7xWP2ycp1gRngpGRnRu4At/hyiLm+UzwTY9xR3C85T0p1gRngpE1ck7xO04MBOmTs3hNe6OQY01wJhhZI+e53ywv45MdgJzRnFneXGFMijXBmWBkTZzTbRsP46OKkH9wCO+vOC7FmuBMMLImzu1Xw87gGbxbAfIT7sDnPcenWBOcCUbWwHnRgYMPbH99VvN1959mUmdi+HyJ+/BDYZ0Ua4IzwcgOOxfNs7yh+dr7d2DIMc2S6d8GrJliTXAmGNkh57JJyY9xO74fALGFV/GC5qwwdFKsCc4EIzvgbJvB/xa3Krt0dxoP4mhBjS5JsSY4E4xUdnZZ7vIXHsZXPTHvqffX0xRrgjPBSEVn17Vhu3B9T8wTKxxniKRYE5wJRio5u36Y/bikJ2YTt/Uc2ycp1gRngpFKzq7NsmgFZ9ccLhy/SlKsCc4EI5WcXZplAw+VWTxaOL5rUqwJzgQjFZ1dmuUuXL5k/xZOttS4Fnu7gAqTYk1wJhip6OzSLMu+4n7UTOLcrenuX5e8t8ZZJsWa4EwwUtHZ1iyTJUWOaW5c9sXs9QncYPFit0NtmMKkWBOcCUYqO9ua5RZcPbftTzytme2c/0fZH3hSs6z59Ny+vdjTBipIijXBmWCksrOtWea79gNNd37YMu64pqu3r9qc4GDLuJKkWBOcCUYqO9ua5fHZ40nco1ki/UvLmHM5hQN4STPLyvm7A46RFGuCM8FIZedkyV30p3hlBvm6I2BR9uAd3IxrCmtdKCnWBGeCkR1wLmuWMbKJn2sesCAp1gRngpEW5//kXI9EZibN2wAAAABJRU5ErkJggg=="
                        alt="">
                      <div style="width: 20%;"></div>
                    </div>
                    <div class="comment-progress">
                      <div style="width: 10%;"></div>
                    </div>
                  </li>
                  <li>
                    <div class="comment-star">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAAgCAYAAAC8eIxyAAADiElEQVR4nNXcvascVRgH4GfXWySKFoIouYJ2gogS1ELFr4hJlPgdP1CihWBhYaOd/4CNEcTSKsZCESxMo3axsBAEtRVUgogfGFEsDFxiMRtyWbI7s3Nmzt3fr9ndmT3vPFu8s+ycszM5+tbbBsh+fDZEoQpJsSY4E4wM5JwOALkXn+KmAWqNnRRrgjPByIDOIZrl9dnjkQFqjZ0Ua4IzwciAztJmuQ77Zs+fw0ZhvTGTYk1wJhgZ2FnaLC9iMnt+Fe4vrDdmUqwJzgQjAztLmmWKZ+e2PV9Qb8ykWBOcCUZGcJY0yz5szm17BJcV1BwrKdYEZ4KREZwlzXKhH0y78VRBzbGSYk1wJhgZwdm3WS7GYwv2rdvVkRRrgjPByEjOVa8O7MYuzZWFSxe8507ciFML9m/h7xWP2ycp1gRngpGRnRu4At/hyiLm+UzwTY9xR3C85T0p1gRngpE1ck7xO04MBOmTs3hNe6OQY01wJhhZI+e53ywv45MdgJzRnFneXGFMijXBmWBkTZzTbRsP46OKkH9wCO+vOC7FmuBMMLImzu1Xw87gGbxbAfIT7sDnPcenWBOcCUbWwHnRgYMPbH99VvN1959mUmdi+HyJ+/BDYZ0Ua4IzwcgOOxfNs7yh+dr7d2DIMc2S6d8GrJliTXAmGNkh57JJyY9xO74fALGFV/GC5qwwdFKsCc4EIzvgbJvB/xa3Krt0dxoP4mhBjS5JsSY4E4xUdnZZ7vIXHsZXPTHvqffX0xRrgjPBSEVn17Vhu3B9T8wTKxxniKRYE5wJRio5u36Y/bikJ2YTt/Uc2ycp1gRngpFKzq7NsmgFZ9ccLhy/SlKsCc4EI5WcXZplAw+VWTxaOL5rUqwJzgQjFZ1dmuUuXL5k/xZOttS4Fnu7gAqTYk1wJhip6OzSLMu+4n7UTOLcrenuX5e8t8ZZJsWa4EwwUtHZ1iyTJUWOaW5c9sXs9QncYPFit0NtmMKkWBOcCUYqO9ua5RZcPbftTzytme2c/0fZH3hSs6z59Ny+vdjTBipIijXBmWCksrOtWea79gNNd37YMu64pqu3r9qc4GDLuJKkWBOcCUYqO9ua5fHZ40nco1ki/UvLmHM5hQN4STPLyvm7A46RFGuCM8FIZedkyV30p3hlBvm6I2BR9uAd3IxrCmtdKCnWBGeCkR1wLmuWMbKJn2sesCAp1gRngpEW5//kXI9EZibN2wAAAABJRU5ErkJggg=="
                        alt="">
                      <div style="width: 40%;"></div>
                    </div>
                    <div class="comment-progress">
                      <div style="width: 0%;"></div>
                    </div>
                  </li>
                  <li>
                    <div class="comment-star">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAAgCAYAAAC8eIxyAAADiElEQVR4nNXcvascVRgH4GfXWySKFoIouYJ2gogS1ELFr4hJlPgdP1CihWBhYaOd/4CNEcTSKsZCESxMo3axsBAEtRVUgogfGFEsDFxiMRtyWbI7s3Nmzt3fr9ndmT3vPFu8s+ycszM5+tbbBsh+fDZEoQpJsSY4E4wM5JwOALkXn+KmAWqNnRRrgjPByIDOIZrl9dnjkQFqjZ0Ua4IzwciAztJmuQ77Zs+fw0ZhvTGTYk1wJhgZ2FnaLC9iMnt+Fe4vrDdmUqwJzgQjAztLmmWKZ+e2PV9Qb8ykWBOcCUZGcJY0yz5szm17BJcV1BwrKdYEZ4KREZwlzXKhH0y78VRBzbGSYk1wJhgZwdm3WS7GYwv2rdvVkRRrgjPByEjOVa8O7MYuzZWFSxe8507ciFML9m/h7xWP2ycp1gRngpGRnRu4At/hyiLm+UzwTY9xR3C85T0p1gRngpE1ck7xO04MBOmTs3hNe6OQY01wJhhZI+e53ywv45MdgJzRnFneXGFMijXBmWBkTZzTbRsP46OKkH9wCO+vOC7FmuBMMLImzu1Xw87gGbxbAfIT7sDnPcenWBOcCUbWwHnRgYMPbH99VvN1959mUmdi+HyJ+/BDYZ0Ua4IzwcgOOxfNs7yh+dr7d2DIMc2S6d8GrJliTXAmGNkh57JJyY9xO74fALGFV/GC5qwwdFKsCc4EIzvgbJvB/xa3Krt0dxoP4mhBjS5JsSY4E4xUdnZZ7vIXHsZXPTHvqffX0xRrgjPBSEVn17Vhu3B9T8wTKxxniKRYE5wJRio5u36Y/bikJ2YTt/Uc2ycp1gRngpFKzq7NsmgFZ9ccLhy/SlKsCc4EI5WcXZplAw+VWTxaOL5rUqwJzgQjFZ1dmuUuXL5k/xZOttS4Fnu7gAqTYk1wJhip6OzSLMu+4n7UTOLcrenuX5e8t8ZZJsWa4EwwUtHZ1iyTJUWOaW5c9sXs9QncYPFit0NtmMKkWBOcCUYqO9ua5RZcPbftTzytme2c/0fZH3hSs6z59Ny+vdjTBipIijXBmWCksrOtWea79gNNd37YMu64pqu3r9qc4GDLuJKkWBOcCUYqO9ua5fHZ40nco1ki/UvLmHM5hQN4STPLyvm7A46RFGuCM8FIZedkyV30p3hlBvm6I2BR9uAd3IxrCmtdKCnWBGeCkR1wLmuWMbKJn2sesCAp1gRngpEW5//kXI9EZibN2wAAAABJRU5ErkJggg=="
                        alt="">
                      <div style="width: 60%;"></div>
                    </div>
                    <div class="comment-progress">
                      <div style="width: 0%;"></div>
                    </div>
                  </li>
                  <li>
                    <div class="comment-star">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAAAgCAYAAAC8eIxyAAADiElEQVR4nNXcvascVRgH4GfXWySKFoIouYJ2gogS1ELFr4hJlPgdP1CihWBhYaOd/4CNEcTSKsZCESxMo3axsBAEtRVUgogfGFEsDFxiMRtyWbI7s3Nmzt3fr9ndmT3vPFu8s+ycszM5+tbbBsh+fDZEoQpJsSY4E4wM5JwOALkXn+KmAWqNnRRrgjPByIDOIZrl9dnjkQFqjZ0Ua4IzwciAztJmuQ77Zs+fw0ZhvTGTYk1wJhgZ2FnaLC9iMnt+Fe4vrDdmUqwJzgQjAztLmmWKZ+e2PV9Qb8ykWBOcCUZGcJY0yz5szm17BJcV1BwrKdYEZ4KREZwlzXKhH0y78VRBzbGSYk1wJhgZwdm3WS7GYwv2rdvVkRRrgjPByEjOVa8O7MYuzZWFSxe8507ciFML9m/h7xWP2ycp1gRngpGRnRu4At/hyiLm+UzwTY9xR3C85T0p1gRngpE1ck7xO04MBOmTs3hNe6OQY01wJhhZI+e53ywv45MdgJzRnFneXGFMijXBmWBkTZzTbRsP46OKkH9wCO+vOC7FmuBMMLImzu1Xw87gGbxbAfIT7sDnPcenWBOcCUbWwHnRgYMPbH99VvN1959mUmdi+HyJ+/BDYZ0Ua4IzwcgOOxfNs7yh+dr7d2DIMc2S6d8GrJliTXAmGNkh57JJyY9xO74fALGFV/GC5qwwdFKsCc4EIzvgbJvB/xa3Krt0dxoP4mhBjS5JsSY4E4xUdnZZ7vIXHsZXPTHvqffX0xRrgjPBSEVn17Vhu3B9T8wTKxxniKRYE5wJRio5u36Y/bikJ2YTt/Uc2ycp1gRngpFKzq7NsmgFZ9ccLhy/SlKsCc4EI5WcXZplAw+VWTxaOL5rUqwJzgQjFZ1dmuUuXL5k/xZOttS4Fnu7gAqTYk1wJhip6OzSLMu+4n7UTOLcrenuX5e8t8ZZJsWa4EwwUtHZ1iyTJUWOaW5c9sXs9QncYPFit0NtmMKkWBOcCUYqO9ua5RZcPbftTzytme2c/0fZH3hSs6z59Ny+vdjTBipIijXBmWCksrOtWea79gNNd37YMu64pqu3r9qc4GDLuJKkWBOcCUYqO9ua5fHZ40nco1ki/UvLmHM5hQN4STPLyvm7A46RFGuCM8FIZedkyV30p3hlBvm6I2BR9uAd3IxrCmtdKCnWBGeCkR1wLmuWMbKJn2sesCAp1gRngpEW5//kXI9EZibN2wAAAABJRU5ErkJggg=="
                        alt="">
                      <div style="width: 80%;"></div>
                    </div>
                    <div class="comment-progress">
                      <div style="width: 0%;"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="information-info">
            <h2 class="app-title">信息</h2>
            <ul class="information-list">
              <li>
                <span class="l">销售商</span>
                <div class="r">{{message.in_name}}</div>
              </li>
              <li>
                <span class="l">兼容性</span>
                <div class="r">
                  {{!message.in_super && message.in_form == 'iOS'?"需要iOS 9.0或更高版本":"需要Android 5.0或更高版本"}}
                </div>
              </li>
              <li>
                <span class="l">大小</span>
                <div class="r">{{(message.in_size / 1024 / 1024).toFixed(2) +"MB"}}</div>
              </li>
              <li>
                <span class="l">更新时间</span>
                <div class="r">{{timestampToTime2(message.in_updatetime)}}</div>
              </li>
            </ul>
          </div>
        </div>
      </el-main>
      <el-footer>
        <div class="content">
          <div class="footer">
            <span @click="mianze">{{$t('lange.disclaimer')}}</span><span>&nbsp;&nbsp;</span><span
              @click="showDialog">{{$t('lange.report')}}</span>
          </div>
        </div>
      </el-footer>
    </div>
    <!-- 举报弹窗 -->
    <Dialog :isShow.sync="isShow" :id="id" :appName="appName" @cancel="cancel" v-if="id"></Dialog>
    <Dialogteach :isTeach.sync="isTeach" @closeTeach="closeTeach"></Dialogteach>

  </div>
</template>
<script>
  import TemplaceMixins from '@/mixins/mixin.js'
  export default {
    mixins: [TemplaceMixins],
    data() {
      return {};
    },
    mounted: function () {
      this.$nextTick(function () {
        if (this.isPassword) {
          this.open()
        }
      })
    },
    methods: {
      open() {
        this.$prompt(this.$t('lange.password'), '', {
          confirmButtonText: this.$t('lange.enter'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
          beforeClose: (value, instance, done) => {
            if (instance._data.inputValue == this.downPwd) {
              this.isPassword = false
              done()
            } else {
              this.$message.error(this.$t('lange.errcode'));
              return false;
            }
          },
          inputErrorMessage: this.$t('lange.errcode'),
        }).then(({
          value
        }) => {
          this.isPassword = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      }
    }
  }

</script>
<style scoped>
  .main {
    width: 100vw;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }

  .content {
    box-sizing: border-box;
    z-index: 99;
  }


  .common {
    padding: 0;
    width: 100%;
    height: 120px;

  }

  .describe .common {
    border-bottom: 1px solid #e5e5e5;
  }

  .name {
    float: left;
    margin-left: 20px;
    height: 106px;
    width: calc(100% - 134px);
  }

  .icon {
    box-shadow: none;
    width: auto;
    height: auto;
    background-color: transparent;
    /* display: flex; */
    float: left;
    align-items: center;
  }

  .icon img {
    width: 104px;
    height: 104px;
    border-radius: 30px;
    border: 1px solid #e5e5e5;
    margin: 0 auto;
  }

  .name-t {
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 20px;
    font-weight: 600;
    text-align: left;
  }

  .rate-info {
    margin: 0 2%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #d8d8d8;
  }

  .rate-info .rate>strong {
    font-size: 14px;
    font-weight: 700;
    color: #888;
  }




  .rate-info .rate>img {
    width: 70px;
    margin-left: 5px;
  }

  .rate-info .rate>p {
    margin: 0px;
    text-align: left;
    color: #d8d8d8;
  }

  .rate-info .classification>strong {
    color: #8e8f92;
    font-size: 14px;
  }

  .rate-info .classification>p {
    color: #d8d8d8;
    font-size: 12px;
    margin: 0px;
  }

  .comment-info {
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    margin: 0px;
  }

  .comment-info .comment-info-title {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bolder;
  }

  .comment-info .comment-info-content {
    display: flex;
    flex-direction: row;
  }

  .comment-info .comment-info-content .comment-info-l>strong {
    font-size: 3.75rem;
    line-height: 2.6875rem;
    color: #4a4a4e;
    font-weight: 700;
  }

  .comment-info .comment-info-content .comment-info-l>p {
    width: 70px;
    text-align: center;
    color: #7b7b7b;
    font-size: 12px;
    margin: 0px;
    margin-top: 9px;
  }

  .comment-info .comment-info-content .comment-info-r {
    margin-left: 24px;
    flex-grow: 1;
  }

  .comment-star-list {
    margin: 0px;
  }

  .comment-info .comment-info-content .comment-info-r .comment-star-list>li {
    margin-top: 4px;
    line-height: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .comment-info .comment-info-content .comment-info-r .comment-star-list .comment-star {
    position: relative;
    width: 46px;
    height: 7px;
  }

  .comment-info .comment-info-content .comment-info-r .comment-star-list .comment-star>img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .comment-info .comment-info-content .comment-info-r .comment-star-list .comment-star>div {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: #fff;
  }

  .comment-info .comment-info-content .comment-info-r .comment-star-list .comment-progress {
    position: relative;
    margin-left: 7px;
    flex-grow: 1;
    height: 2px;
    background: #e9e9ec;
    border-radius: 2px;
  }

  .comment-info .comment-info-content .comment-info-r .comment-star-list .comment-progress>div {
    position: absolute;
    left: 0;
    width: 0;
    height: 2px;
    background: #4a4a4e;
    border-radius: 2px;
    width: 90%;
  }

  .information-info {
    padding: 12px 0;
    margin: 0px;
  }

  .information-info .app-title {
    margin: 0px;
    margin-bottom: 4px;
    font-size: 18px;
    font-weight: bolder;
  }

  .information-info .information-list {
    padding: 0;
    margin-bottom: 0px;
  }

  .information-info .information-list>li {
    font-size: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 3.5;
    border-bottom: 1px solid #f2f2f2;
  }

  .information-info .information-list>li .l {
    color: #737379;
  }

  .information-info .information-list>li .r {
    margin-left: 19px;
    flex: 1;
    text-align: right;
    line-height: 14px;
  }

  .top-pwd {
    position: absolute;
    left: 50%;
    top: -30px;
    margin-left: -30px;
    width: 60px;
    height: 60px;
    border: 1px solid #157df1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fafafa;
  }

  .template-pwd {
    position: relative;

  }

  .top-pwd .iconfont {
    color: #157df1;
    font-size: 30px;
  }

  .el-footer {
    height: 24px !important;
  }

  .footer {
    margin: 0px;
    margin-bottom: 0px;
    padding-bottom: 8px;
    font-size: 12px;
    text-align: center;
  }

  .footer span {
    color: #157df1;
  }

  .pc-name {
    display: none;
  }

  .main {
    z-index: 90;
    padding: 20px;
    padding-bottom: 0px;
  }


  .download {
    text-align: center;
    width: 100%;
    height: 144px;
  }


  .download_but {
    text-align: center;
  }

  .download_but a {
    padding: 0 36px;
    margin-bottom: 10px;
    height: 30px;
    line-height: 28px;
    border-radius: 0px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #157df1;
    display: inline-block;
    text-decoration: none;
    border-radius: 15px;
  }


  .facility {
    color: #999;
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
  }

  /* .ewm {
    width: 200px;
    overflow: hidden;
    margin: 35px auto 0;
    text-align: center;
    margin-top: 25px;
  }

  .ewm img {
    width: 120px;
    height: 120px;
    display: block;
    margin: 0 auto;
    border: 1px solid #e5e5e5;
  }

  .ewm div {
    color: #999;
    font-size: 14px;
    width: 200px;
    text-align: center;
  } */

  .describe {
    margin-top: 45px;
    padding-top: 0px;
  }

  .hr {
    display: none;
  }

  .describe-block-t {
    font-weight: 600;
  }

  .describe-block-p {
    color: #555;
    font-size: 13px;
    font-weight: 400;
    word-wrap: break-word;
  }

  .template-pwd {
    width: auto;
    margin: 80px 0px;
    background-color: #fafafa !important;
    padding: 60px 30px 20px !important;
    height: auto !important;
    border-radius: 5px;
  }

  .form-group {
    text-align: center;
    margin-bottom: 15px;
  }

  .form-group label {
    font-size: 12px;
    display: block;
    margin-bottom: 10px;
  }

  .form-control {
    border-color: #e5e5e5;
    margin-top: 5px;
    height: 28px;
    box-shadow: none;
    border-radius: 5px;
    color: #fff;
    background-color: rgb(59, 59, 59) !important;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    width: 80%;
    border: 1px solid #ccc;
  }

  .decoding {
    padding: 0;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    text-align: center;
    font-size: 15px;
    /* margin-top: 19px;
    margin-bottom: 10px; */
    width: 170px;
    color: #fff;
    background-color: #157df1;
    margin: 19px auto 10px;
    display: block;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid transparent;
  }

  .down_teach {
    display: block;
    text-align: center;
    padding: 5px;
    /* width: 100%; */
    box-sizing: border-box;
    position: relative;
  }

  .down_teach p {
    margin: 0px;
    color: #157df1;
    font-size: 14px;
  }

  .install_load {
    color: #1abc9c;
    text-align: center;
    margin-top: 10px;
  }

  .ios_but {
    text-align: center;
    margin-top: 10px;
  }

  .ios_but a {
    padding: 0 36px;
    margin-bottom: 10px;
    height: 40px;
    width: 120px;
    line-height: 38px;
    border-radius: 20px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #40acf1;
    display: inline-block;
    text-decoration: none;
  }

  .template-footer {
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/TemplateSeven.vue